import { useState } from 'react';

import { FETCHER_DROPDOWN_OPTIONS, type ThirdPartyFetcher } from '../../../../shared/fetchers';
import { FormLabelVariant, LabeledSelect, LabeledTextInput } from '../../generic';

import styles from './SearchDependency.module.less';

const SearchDependency = () => {
  const [packageManager, setPackageManager] = useState<ThirdPartyFetcher | undefined>(undefined);
  const [name, setName] = useState<string>('');
  const [version, setVersion] = useState<string>('');

  return (
    <div>
      <p className={styles.overview}>
        Search for an existing package and add it as a vendored dependency to your project.
      </p>
      <h3 className={styles.header}>
        Package Details
      </h3>

      <div className={styles.field}>
        <LabeledSelect
          id="search-dependency-package-manager"
          label="Package Manager"
          variant={FormLabelVariant.Filter}
          placeholder="Please choose..."
          options={FETCHER_DROPDOWN_OPTIONS}
          value={FETCHER_DROPDOWN_OPTIONS.find((opt) => opt.value === packageManager)}
          onChange={(opt) => setPackageManager(opt?.value)}
        />
        <p className={styles.notes}>This tells FOSSA where to grab the same package for our analysis.</p>
      </div>

      <div className={styles.field}>
        <LabeledTextInput
          id="search-dependency-name"
          size="small"
          label="Name"
          labelVariant={FormLabelVariant.Filter}
          placeholder="Enter a package name"
          value={name}
          onChange={(value) => setName(value)}
        />
      </div>

      <div className={styles.field}>
        <LabeledTextInput
          id="search-dependency-version"
          size="small"
          label="Version"
          labelVariant={FormLabelVariant.Filter}
          placeholder="Enter a version number, eg. v1 or 1.0"
          value={version}
          onChange={(value) => setVersion(value)}
        />
      </div>
    </div>
  );
};

export default SearchDependency;
